var _mask, _g, _rect, _mask2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSignGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 12,
    height: 12,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 12,
    height: 12,
    fill: "#272D2D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.12134,
    y: 5,
    width: 3,
    height: 3,
    transform: "rotate(45 7.12134 5)",
    fill: "#F6F7FB"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#272D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 512,
    height: 512,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSignGrey);
export default __webpack_public_path__ + "static/media/checkSign-grey.46d6ccf4e111e20c2221015850981d8b.svg";
export { ForwardRef as ReactComponent };